import { MuiTheme } from 'material-ui/styles';
import { defaultTheme } from './default/index';
import { metropolisTheme } from './metropolis/index';
import { sportappTheme } from './sportapp/index';
import { patrickTheme } from './patrick/index';
import { buetzerBuebeTheme } from './buetzerBuebeTheme/index';
import {
  BlackColor,
  IBackOfficeMainTheme,
  IBackOfficeNavBarTheme,
  IBackOfficeTheme,
  WhiteColor
} from './theme';

const LEFT_NAV_WIDTH = 237;

export enum BackOfficeThemeType {
  defaultTheme,
  metropolisTheme,
  sportappTheme,
  patrickTheme,
  buetzerBuebeTheme
}

export function themeFactory(themeType: BackOfficeThemeType) {
  switch (themeType) {
    case BackOfficeThemeType.metropolisTheme:
      return metropolisTheme;

    case BackOfficeThemeType.sportappTheme:
      return sportappTheme;

    case BackOfficeThemeType.patrickTheme:
      return patrickTheme;

    case BackOfficeThemeType.buetzerBuebeTheme:
      return buetzerBuebeTheme;

    case BackOfficeThemeType.defaultTheme:
    default:
      return defaultTheme;
  }
}

export function generateNavigationTheme(
  theme: IBackOfficeTheme
): IBackOfficeNavBarTheme {
  return {
    openedWidth: LEFT_NAV_WIDTH,
    logo: theme.navBar.logo,
    backgroundColor: theme.navBar.backgroundColor,
    activeBackgroundColor: theme.navBar.activeBackgroundColor,
    color: theme.navBar.color,
    iconColor: theme.navBar.iconColor,
    BGImage: theme.navBar.backgroundImage
  };
}

export function generateMainTheme(
  theme: IBackOfficeTheme
): IBackOfficeMainTheme | MuiTheme {
  const primary1Color = theme.primaryColor;
  const accent1Color = theme.accentColor;
  const accent2Color = theme.accent2Color;
  const backgroundColor = theme.backgroundColor;
  const alternateTextColor = theme.alternateTextColor;
  const labelColor = theme.labelColor;
  const hintColor = theme.hintColor;
  const raisedButtonPrimaryColor = theme.raisedButtonPrimaryColor;
  const raisedButtonSecondaryColor = theme.raisedButtonSecondaryColor;

  return {
    logo: theme.logo,
    nonLogged: theme.nonLogged,
    fontFamily: '"Open Sans", sans-serif',
    fontSize: 16,
    defaultPadding: 16,
    palette: {
      greyColor: '#aeaeae',
      alternateTextColor: alternateTextColor,
      primary1Color,
      accent1Color,
      accent2Color,
      labelColor: labelColor,
      hintColor
    },
    drawer: {
      color: theme.navBar.backgroundColor,
      width: LEFT_NAV_WIDTH
    },
    navBar: generateNavigationTheme(theme),

    flatButton: {
      color: 'transparent',
      primaryTextColor: hintColor || primary1Color,
      secondaryTextColor: raisedButtonSecondaryColor || accent1Color
    },

    textField: {
      hintColor: hintColor || primary1Color,
      textColor: '#000',
      textSize: 16
    },

    raisedButton: {
      fontWeight: 'bold',
      textTransform: 'uppercase',
      primaryTextColor: WhiteColor,
      primaryColor: raisedButtonPrimaryColor || primary1Color,
      secondaryTextColor: WhiteColor,
      secondaryColor: raisedButtonSecondaryColor || accent1Color
    },

    radioButton: {
      labelColor: hintColor || primary1Color,
      borderColor: accent1Color,
      checkedColor: accent1Color
    },

    button: {
      height: 48
    },
    tableHeaderColumn: {
      spacing: 22,
      bgColor: backgroundColor,
      textColor: WhiteColor,
      height: 40
    },
    tableRowColumn: {
      spacing: 22
    },
    tableRow: {
      height: 40,
      textColor: 'black'
    },

    slider: {
      handleColorZero: accent1Color,
      handleFillColor: accent1Color,
      selectionColor: accent1Color,
      rippleColor: accent1Color
    },

    datePicker: {
      textColor: '#000',
      selectTextColor: labelColor
    },

    timePicker: {
      textColor: '#000',
      selectTextColor: labelColor
    },

    toolbar: {
      backgroundColor: '#e6e6e6'
    }
  };
}



// WEBPACK FOOTER //
// ./src/themes/index.ts